import React from 'react';
import Span from '@inspire/ui/chakra/Span';

const Euros = ({ children }) => <Span whiteSpace="nowrap">{children} €</Span>;

export default Euros;
